import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function BeritaList() {
  const [berita, setBerita] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBerita = async () => {
      try {
        const q = query(collection(db, "berita"), orderBy("tanggal", "desc"));
        const snap = await getDocs(q);
        const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setBerita(data);
      } catch (err) {
        console.error("fetch berita error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBerita();
  }, []);

  if (loading) return <p className="text-center mt-5">Memuat berita...</p>;
  if (berita.length === 0) return <p className="text-center mt-5">Belum ada berita.</p>;

  return (
    <section className="berita-list-section py-5">
      <div className="container">
        <h3 className="fw-bold mb-4 text-center text-primary">Berita Sekolah</h3>
        <div className="row g-4">
          {berita.map((b, idx) => (
            <motion.div
              key={b.id}
              className="col-md-6 col-lg-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="card h-100 shadow-sm">
                {b.gambar && (
                  <img
                    src={b.gambar}
                    className="card-img-top"
                    alt={b.judul}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                )}
                <div className="card-body">
                  <p className="text-muted small mb-1">{new Date(b.tanggal).toLocaleDateString()}</p>
                  <Link
                    to={`/berita/${b.id}`}
                    className="card-title h6 text-decoration-none text-dark"
                  >
                    {b.judul}
                  </Link>
                  {b.deskripsi && (
                    <p className="mt-2 text-secondary">
                      {b.deskripsi.length > 100 ? b.deskripsi.substring(0, 100) + "..." : b.deskripsi}
                    </p>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
